import { all, fork } from 'redux-saga/effects';
import { tempatesSagaWatcher } from 'components/Template/Tempate.saga';
import { previewSagaWatcher } from 'components/Preview/Preview.saga';
import { reportSettingsSagaWatcher } from 'components/ReportSettings/ReportSettings.saga';
import { dashboardSagaWatcher } from 'components/Dashboard/Dashboard.saga';
import { LoadPreviewPageSagaWatcher } from 'components/Template/LoadPreviewPage.saga';
import { tourSagaWatcher } from 'components/UserTour/Tour.saga';

export default function* rootSaga() {
	yield all([
		fork(LoadPreviewPageSagaWatcher),
		fork(tempatesSagaWatcher),
		fork(previewSagaWatcher),
		fork(reportSettingsSagaWatcher),
		fork(dashboardSagaWatcher),
		fork(tourSagaWatcher)
	]);
}
